import { render, staticRenderFns } from "./SchoolAccount.vue?vue&type=template&id=020f55a2&scoped=true"
import script from "./SchoolAccount.vue?vue&type=script&lang=js"
export * from "./SchoolAccount.vue?vue&type=script&lang=js"
import style0 from "./SchoolAccount.vue?vue&type=style&index=0&id=020f55a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020f55a2",
  null
  
)

export default component.exports